import axios from 'axios';
import Common from './Common';
export default {
    //seller
    getThreadsSeller(id) {
        return axios.get(Common.api + 'get-all-threads-seller/' + id);
    },
    getConversationSeller(buyer_id, seller_id) {
        return axios.get(Common.api + 'get-all-chated-seller/' + buyer_id + '/' + seller_id);
    },
    getConversationBuyer(buyer_id, seller_id) {
        return axios.get(Common.api + 'get-all-chated-buyer/' + seller_id + '/' + buyer_id);
    },
    getThreadsBuyer(id) {
        return axios.get(Common.api + 'get-threads-buyer/' + id);
    },
    sendConversationInitiation(data) {
        return axios.post(Common.api + 'store-msg-initiation', data);
    },
    sendConversationSeller(data) {
        return axios.post(Common.api + 'store-msg' , data);
    },
    sendConversationAffiliator(data) {
        return axios.post(Common.api + 'store-msg' , data);
    },
    //Buyer
    getThreadsBuyerSolo(id) {
        return axios.get(Common.api + 'get-threads-buyer-solo/' + id);
    },
    getConversationBuyerSolo(buyer_id, seller_id) {
        return axios.get(Common.api + 'get-all-chated-buyer-solo/' + buyer_id + '/' + seller_id);
    },
    getConversationSys(user) {
        return axios.get(Common.api + 'get-all-chated-sys/' + user);
    },
    sendConversationSys(data) {
        return axios.post(Common.api + 'get-all-chated-sys/' , data);
    }

    //Affiliator
}